/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc service
 * @name BannerAlertDataTransformer
 * @description
 *     DataTransformer for BannerAlertCollection. Wraps each result item in a config object
 *     as expected by the Item/Collection framework.
 */
angular.module('aviApp').factory('BannerAlertDataTransformer', [
'RevisedDataTransformer', RevisedDataTransformer => {
    return class BannerAlertDataTransformer extends RevisedDataTransformer {
        /**
         * Transform the API response to wrap each result in a config object.
         * @param {Object} rsp - API response.
         * @returns {Object} - Transformed response.
         * @override
         */
        processResponse(rsp) {
            if (rsp?.data?.results && Array.isArray(rsp?.data?.results)) {
                rsp.data.results = rsp.data.results.map(item => ({
                    config: item,
                }));
            }

            return rsp;
        }
    };
}]);

